import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import "./DisableLogs";

import { lazy } from "react";
import LandingJazzCashRoutes from "./JazzCashApp/route";
const App = lazy(() => import("./App"));
const jcroutes = ["/landing", "/jc"];
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <BrowserRouter>
    {jcroutes.some((route) => window.location.pathname.includes(route)) ? (
      <LandingJazzCashRoutes />
    ) : (
      <App />
    )}
  </BrowserRouter>,
);
reportWebVitals();
